import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import moment from 'moment'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {
  InputTextWrapper,
  SelectWrapper,
  InputDateWrapper,
  SelectAsyncWrapper,
} from '../../../../../../components/UI/Form/Input'
import {Switch} from '../../../../../../components/UI/Switch'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {ModalComponent} from '../../../../components/Modal'
import {useUserByProfile} from '../../../../hooks'
import {confirmModal, ShowSnackBar} from '../../../../../../util/functions'
import {startProcessOutput} from '../../../../services'
import {SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import Swal from 'sweetalert2'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {yupResolver} from '@hookform/resolvers/yup'
import {processOutBatch} from '../../../../schema/laundryBatch'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  data?: any[]
  dataTable?: any[]
}

const Salida: FC<Props> = ({show, setShow, data = [], dataTable = []}) => {
  const [searching, setIsSearching] = useState<boolean>(false)
  const {deliveryLocation, getDeliveryLocationList} = useTableForMaster()
  const {getUserByProfileData} = useUserByProfile()
  const {setUpdateTable, clearSelected} = useKTable()
  const methods = useForm({
    resolver: yupResolver(processOutBatch),
  })

  const {
    setValue,
    handleSubmit,
    register,
    watch,
    formState: {errors},
  } = methods
  useEffect(() => {
    getDeliveryLocationList()
    setValue('fechaSalida', moment().format('YYYY-MM-DD'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    setValue('countOrder', data.length)
    setValue('FinalizarSalidad', true)
    const getFirstDate = dataTable.filter((item) => item.id === data[0])
    setValue('fechaRecepcion', getFirstDate[0].fechaRecepcion || '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  useEffect(() => {
    const value = deliveryLocation.filter((item) => item.codigo === 'EN HABITACIÓN')[0]?.label || ''
    setValue('lugarSalida', value)
  }, [deliveryLocation])
  const onSubmit = async (dataForm: any) => {
    try {
      setIsSearching(true)
      let obj = {
        ...dataForm,
        TipoProceso: 'SALIDA',
        ordenIds: data,
      }
      const result = await confirmModal({
        title: 'Esta seguro de generar Lote',
        bodyText: '',
        icon: 'warning',
        showCancelButton: true,
        textButtonCancel: 'No',
        textButtonConfirm: 'Sí',
      })
      if (result.isConfirmed) {
        const {data: response} = await startProcessOutput(obj)
        if (!response.error) {
          ShowSnackBar(SUCCESS_MESSAGE_CREATE)
          setUpdateTable(true)
          setShow(false)
          setIsSearching(false)
          Swal.close()
        } else {
          ShowSnackBar(response.message, 'error')
        }
      }
    } catch (error) {
      ShowSnackBar('ERROR DEL SISTEMA', 'error')
    } finally {
      clearSelected()
    }
  }
  const loadOptions = async (inputValue: string, callback: (options: any[]) => void) => {
    if (inputValue.length < 3) { return [] }
    try {
      const response = await getUserByProfileData(inputValue)
      const mappedGuests = response.map((item: any) => ({
        value: item.id,
        label: `${item.nombres} ${item.apellidos}`,
        ...item,
      }))
      return mappedGuests
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const getInformationColaborador = async (e: any) => {
    let value = e ? e : ''
    setValue('responsable', value.label)
    setValue('responsableId', value.value)
  }

  return (
    <ModalComponent
      show={show}
      setShow={setShow}
      title='GENERAR LOTE'
      type='modal'
      size='lg'
      showFooter={false}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className='m-2'>
          <div className='row'>
            <div className='col-sm-12 col-lg-4'>
              <InputTextWrapper
                labelText='Cantidad de Órdenes de Lavado'
                name='countOrder'
                disabled
              />
            </div>
          </div>
          <div className='row mb-4'>
            <div className='col-sm-12 col-lg-4'>
              <SelectWrapper
                labelText='Lugar de Salida'
                name='lugarSalida'
                data={deliveryLocation}
                required
              />
            </div>
            <div className='col-sm-12 col-lg-4'>
              <SelectAsyncWrapper
                labelText='Datos del responsable'
                name='responsableId'
                loadOptions={loadOptions}
                onChangeValue={getInformationColaborador}
                value={
                  watch('responsableId')
                    ? {
                        value: watch('responsableId') || '',
                        label: watch('responsable') || '',
                      }
                    : null
                }
                required
              />
            </div>

            <div className='col-sm-12 col-lg-4'>
              <InputDateWrapper labelText='Fecha Salida' name='fechaSalida' />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-lg-6'>
              <label>Finalizar salida:</label>
              <Switch register={register} name='FinalizarSalidad' errors={errors} />
            </div>
          </div>
          <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
            <Button
              label='Generar Lote'
              typeBtn='submit'
              loading={searching}
              disabled={searching}
            />
          </ButtonWrapper>
        </form>
      </FormProvider>
    </ModalComponent>
  )
}

export {Salida}
